import { images, missionIcon, visionIcon } from "../source";

export const missionVissionData = [
  {
    id: 1,
    icon: missionIcon,
    img: images.mission.image,
    alt: images.mission.alt,
    title: "Mission",
    desc: "To share <strong>deep and actionable life wisdom</strong> from spiritual teachers and leaders, fostering a community that helps individuals gain insight, cultivate a richer life, and realize their inherent path.",
  },
  {
    id: 2,
    icon: visionIcon,
    img: images.vision.image,
    alt: images.vision.alt,
    bgColor: "#597931",
    title: "Vision",
    desc: "A world where every individual discovers their unique path, illuminated by diverse perspectives and timeless wisdom.",
  },
];

export const partnerLogoData = [
  {
    id: 1,
    img: images.partner01.image,
    alt: images.partner01.alt,
  },
  {
    id: 2,
    img: images.partner02.image,
    alt: images.partner02.alt,
  },
  {
    id: 3,
    img: images.partner03.image,
    alt: images.partner03.alt,
  },
  {
    id: 4,
    img: images.partner04.image,
    alt: images.partner04.alt,
  },
  {
    id: 5,
    img: images.partner05.image,
    alt: images.partner05.alt,
  },
  {
    id: 6,
    img: images.partner06.image,
    alt: images.partner06.alt,
  },
  {
    id: 7,
    img: images.partner07.image,
    alt: images.partner07.alt,
  },
  {
    id: 8,
    img: images.partner08.image,
    alt: images.partner08.alt,
  },
];
